export default "__VITE_ASSET__bdb04812__"